import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import LocalLawFinderLogo from "./LocalLawFinderLogo";

// Single source of truth for the visible contact email.
// Update this value when the custom-domain inbox is finalized.
const CONTACT_EMAIL = "admin@locallawfinder.com";

export default function Footer() {
    return (
        <footer className="border-t border-border bg-card/40 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
                <div className="col-span-2">
                    <div className="flex items-center gap-3 mb-2">
                        <LocalLawFinderLogo size={40} className="rounded-md flex-shrink-0" />
                        <div>
                            <div className="font-serif text-2xl font-bold leading-tight">LocalLawFinder</div>
                            <div className="text-xs text-muted-foreground">A product of <span className="font-semibold text-foreground">Young Black Man Inc.</span></div>
                        </div>
                    </div>
                    <p className="mt-4 text-muted-foreground max-w-md leading-relaxed">
                        Local legal answers first. Local lawyers when you need them. Nationwide legal information and county-matched attorney discovery.
                        Legal information only — not legal advice. Speak with a local attorney for guidance on your specific situation.
                    </p>
                    <a href={`mailto:${CONTACT_EMAIL}`}
                       className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-primary hover:underline"
                       data-testid="footer-contact-email">
                        <Mail className="h-4 w-4" /> {CONTACT_EMAIL}
                    </a>
                </div>
                <div>
                    <div className="ll-label mb-3">For Consumers</div>
                    <ul className="space-y-2">
                        <li><Link to="/" className="hover:text-primary">Ask a question</Link></li>
                        <li><a href="/#categories" className="hover:text-primary">Practice areas</a></li>
                        <li><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-primary">Contact us</a></li>
                    </ul>
                </div>
                <div>
                    <div className="ll-label mb-3">For Attorneys</div>
                    <ul className="space-y-2">
                        <li><Link to="/for-attorneys" className="hover:text-primary">Why join</Link></li>
                        <li><Link to="/for-attorneys#pricing" className="hover:text-primary">County pricing</Link></li>
                        <li><Link to="/attorney/auth" className="hover:text-primary">Sign in / Register</Link></li>
                        <li><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-primary">Contact us</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
                    <span>© {new Date().getFullYear()} Young Black Man Inc. All rights reserved.</span>
                    <span>Legal information only — not legal advice.</span>
                </div>
            </div>
        </footer>
    );
}
